export default __webpack_public_path__ + "static/media/francheville20.68166340.jpg";